import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { AuthFacade } from '../../../store/auth/auth.facade';

@Injectable({
  providedIn: 'root'
})
export class SoftwareDistributionAdminGuard {

  constructor(
    private readonly authFacade: AuthFacade,
    private readonly router: Router) {
  }

  /**
   * Allows only admins for Software Distribution to go to the global user replacement screen
   */
  canActivate(): Observable<boolean> {
    this.authFacade.getUserInfo();

    return this.authFacade.userInfo$
      .pipe(
        first(res => res !== null),
        map((rights) => {
          if (rights.softwareDistributionAdmin) {
            return true;
          }

          this.router.navigateByUrl('/');
          return false;
        })
      );
  }
}
